module.exports = __webpack_public_path__ + "static/1333470317.a541712a.jpg";